import { useEffect, useState } from "react"
import style from "../style/Weather.module.css"

interface WeatherPeriod {
    number: number;
    detailedForecast: string,
    icon: string,
    name: string,
    shortForecast: string,
    temperature: number,
    temperatureUnit: string
}



const forecastBoston = 'https://api.weather.gov/gridpoints/BOX/72,90/forecast'

function Weather(){
    const [weatherPeriods, setWeather] = useState<WeatherPeriod[]>()
    const [dataIsLoaded, setDataIsLoaded] = useState(false);
    const [dataFailedToLoad, setDataFailedToLoad] = useState(false);

    useEffect(() => {
        async function getWeather(){
            try {
                const response = await fetch(forecastBoston)
                if (!response.ok){
                    throw new Error(`HTTP error! Status: ${response.status}`);
                } else {
                    let json = await response.json()
                    setWeather(json.properties.periods);
                    setDataIsLoaded(true);
                }
            } catch (err) {
                setDataFailedToLoad(true)
                console.log(err)
            }
        }
        getWeather()
    }, []);

    const getWeek = () => {
        let days = weatherPeriods?.map((period)=>{
            return <article className={style.day} key={period.number}>{getDay(period)}</article>
        })

        return (
            <div className={style.weatherList}>
                {days}
            </div>
        )
    }
    
    const getDay = (period: WeatherPeriod) => {
        return (
            <>
                <div className={style.dayInfo}>
                    <div>
                        <h3>{period.name}</h3>
                    </div>
                    <div>
                        <b>Summary:</b> {period.shortForecast}
                    </div>
                    <div>
                        <b>Temperature:</b> {period.temperature} ° {period.temperatureUnit}
                    </div>
                </div>
                <div className={style.icon}>
                    <img width={100} src={period.icon}  alt={period.detailedForecast}/>
                </div>

            </>
        )

    }



    if (!dataIsLoaded) {
        return (
            <div>
                {dataFailedToLoad ? <h2>Data Failed To Load</h2> : <h2>Boston Weather Loading</h2>}
            </div>
        );
    } else {
        return (
            <div className={style.background}>
                <h2>Boston Weather</h2>
                <p>Source: <a href="https://www.weather.gov/documentation/services-web-api">https://www.weather.gov/documentation/services-web-api</a></p>
                <div></div>
                {getWeek()}
            </div>
        );
    }

}

export default Weather